import React, { FC } from "react";
import Button from "components/Button/Button";
import { ButtonColor, ButtonVariant } from "enums/Button";
import { useTranslation } from "react-i18next";
import { Notice } from "./UsdtDepositForm.styles";

interface LoadFailedNoticeProps {
  message: string;
  onRetry: () => void;
}

// Blocks the flow instead of falling back to "create": a lookup that failed
// must never let the user allocate a second deposit address.
const LoadFailedNotice: FC<LoadFailedNoticeProps> = ({ message, onRetry }) => {
  const { t } = useTranslation("common");

  return (
    <Notice role="alert">
      {message}
      <Button
        variant={ButtonVariant.Bordered}
        color={ButtonColor.Neutral}
        onClick={onRetry}
      >
        {t("usdtDeposit.retry")}
      </Button>
    </Notice>
  );
};

export default LoadFailedNotice;
